import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { companyService } from '../services';
import Layout from '../components/Layout';
import { Card, Button } from '../components/ds';
import StammdatenTab from '../components/settings/StammdatenTab';
import BenachrichtigungenTab from '../components/settings/BenachrichtigungenTab';
import AbonnementTab from '../components/settings/AbonnementTab';
import { useIsMobile } from '../hooks/useMediaQuery';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

const TABS = [
  { key: 'stammdaten', label: 'Stammdaten' },
  { key: 'benachrichtigungen', label: 'Benachrichtigungen' },
  { key: 'abonnement', label: 'Abonnement' },
];

const SettingsPage = () => {
  const { section = 'stammdaten' } = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await companyService.getMyCompany();
      setCompany(res.data);
    } catch (err) {
      if (err.response?.status === 404) {
        navigate('/dashboard', { replace: true });
        return;
      }
      setError('Einstellungen konnten nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  return (
    <Layout>
      <div style={{ padding: isMobile ? '20px 16px 32px' : '36px 40px 48px', fontFamily: FONT, maxWidth: 920 }}>
        <h1 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 700, color: '#101623', letterSpacing: '-0.011em' }}>
          Einstellungen
        </h1>
        <p style={{ margin: '0 0 24px', fontSize: 13, color: '#8A93A3' }}>
          Stammdaten, Benachrichtigungen und Abonnement verwalten
        </p>

        {/* ── Tabs ── */}
        <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #D7DCE4', marginBottom: 24 }}>
          {TABS.map(t => {
            const active = section === t.key;
            return (
              <button
                key={t.key}
                onClick={() => navigate(`/settings/${t.key}`)}
                style={{
                  padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer',
                  fontFamily: FONT, fontSize: 13.5, fontWeight: active ? 700 : 500,
                  color: active ? '#1E4FBE' : '#667085',
                  borderBottom: active ? '2px solid #1E4FBE' : '2px solid transparent',
                  marginBottom: -1,
                }}
              >
                {t.label}
              </button>
            );
          })}
        </div>

        {loading && (
          <div style={{ color: '#8A93A3', fontSize: 14 }}>Lädt…</div>
        )}

        {!loading && error && (
          <Card padding={22}>
            <p style={{ margin: '0 0 14px', fontSize: 13, color: '#C22B31' }}>{error}</p>
            <Button size="md" onClick={load}>Erneut versuchen</Button>
          </Card>
        )}

        {!loading && !error && company && section === 'stammdaten' && (
          <StammdatenTab company={company} onCompanyChange={setCompany} />
        )}

        {!loading && !error && company && section === 'benachrichtigungen' && (
          <BenachrichtigungenTab />
        )}

        {!loading && !error && company && section === 'abonnement' && (
          <AbonnementTab />
        )}
      </div>
    </Layout>
  );
};

export default SettingsPage;
